// "Necesito factura": muestra los campos, valida el RUT chileno y guarda todo como atributos del carrito.
// Los escuchadores van en `document` (delegación): el tema redibuja el carrito (morph de secciones, carrito lateral)
// y reemplaza los nodos internos, así que escuchadores puestos en la casilla se perdían y a veces no se desplegaba.
(() => {
  if (window.arelaFacturaLista) return;
  window.arelaFacturaLista = true;

  const limpiarRut = (r) => r.replace(/[^0-9kK]/g, '').toUpperCase();
  function rutValido(rut) {
    const r = limpiarRut(rut);
    if (r.length < 8) return false;
    const cuerpo = r.slice(0, -1), dv = r.slice(-1);
    let suma = 0, mult = 2;
    for (let i = cuerpo.length - 1; i >= 0; i--) { suma += Number(cuerpo[i]) * mult; mult = mult === 7 ? 2 : mult + 1; }
    const res = 11 - (suma % 11);
    const esperado = res === 11 ? '0' : res === 10 ? 'K' : String(res);
    return dv === esperado;
  }
  function formatoRut(rut) {
    const r = limpiarRut(rut); if (r.length < 2) return rut;
    return r.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + r.slice(-1);
  }

  // Estado elegido por el cliente en esta visita: sobrevive a los redibujos aunque el atributo aún no se haya guardado.
  let quiere = null;
  const partes = (el) => ({
    check: el.querySelector('input[type=checkbox]'),
    campos: el.querySelector('.arela-factura__campos'),
    error: el.querySelector('.arela-factura__error'),
  });
  const visibles = () => [...document.querySelectorAll('arela-factura')].filter((el) => el.offsetParent !== null);
  const activo = () => visibles()[0] || document.querySelector('arela-factura');

  function sincronizar(el) {
    const { check, campos } = partes(el);
    if (!check || !campos) return;
    if (quiere !== null) check.checked = quiere;
    campos.hidden = !check.checked;
  }
  function datos(el) {
    const { check } = partes(el);
    const d = { 'Necesita factura': check.checked ? 'Sí' : 'No' };
    el.querySelectorAll('.arela-factura__campos input').forEach((i) => { d[i.dataset.campo] = check.checked ? i.value.trim() : ''; });
    return d;
  }
  function validar(el) {
    if (!partes(el).check.checked) return '';
    const d = datos(el);
    const faltan = Object.entries(d).filter(([k, v]) => k !== 'Necesita factura' && !v).map(([k]) => k.replace('Factura ', ''));
    if (faltan.length) return 'Para emitir tu factura completa: ' + faltan.join(', ') + '.';
    if (!rutValido(d['Factura RUT'])) return 'El RUT ingresado no es válido. Revisa el número y el dígito verificador.';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d['Factura Correo'])) return 'Revisa el correo para la factura.';
    return '';
  }
  function mostrarError(el, msg) {
    const { error } = partes(el);
    error.textContent = msg; error.hidden = false;
    error.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  let pendiente = null, guardado = true;
  async function guardar(el) {
    const { error } = partes(el);
    if (error) error.hidden = true;
    guardado = false;
    pendiente = fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: datos(el) }),
    }).catch(() => {});
    await pendiente; pendiente = null; guardado = true;
  }

  // Casilla y campos: un solo escuchador para todas las instancias, presentes y futuras.
  document.addEventListener('change', (e) => {
    const el = e.target.closest && e.target.closest('arela-factura');
    if (!el) return;
    const i = e.target;
    if (i.type === 'checkbox') {
      quiere = i.checked;
      document.querySelectorAll('arela-factura').forEach(sincronizar);
    } else if (i.dataset.campo === 'Factura RUT' && i.value) {
      i.value = formatoRut(i.value);
    }
    guardar(el);
  });

  // Bloquea el envío al checkout (clic, Enter o envío interno del tema) si pidió factura y faltan datos.
  // Si todo está OK, se asegura de que los datos queden guardados antes de seguir.
  document.addEventListener('submit', async (e) => {
    const s = e.submitter;
    if (!s || !(s.id === 'checkout' || s.name === 'checkout')) return;
    const el = (s.form && s.form.querySelector('arela-factura')) || activo();
    if (!el || !partes(el).check.checked) return;
    const msg = validar(el);
    if (msg) { e.preventDefault(); e.stopImmediatePropagation(); mostrarError(el, msg); return; }
    if (pendiente || !guardado) {
      e.preventDefault(); e.stopImmediatePropagation();
      await guardar(el);
      s.click();
    }
  }, true);

  // Elemento propio solo para dejar los campos en el estado correcto cada vez que el tema lo vuelve a pintar.
  class ArelaFactura extends HTMLElement {
    connectedCallback() { sincronizar(this); }
  }
  if (!customElements.get('arela-factura')) customElements.define('arela-factura', ArelaFactura);
  // Tras un morph el elemento puede seguir conectado pero con hijos nuevos: resincroniza.
  new MutationObserver(() => document.querySelectorAll('arela-factura').forEach(sincronizar))
    .observe(document.body, { childList: true, subtree: true });
})();
